// extracted by mini-css-extract-plugin
export default {"btn":"ButtonEdit_btn__sNf-O","btn_1":"ButtonEdit_btn_1__SC5bY"};